import React from 'react'

import { Form } from 'react-bootstrap'

const IndexView = ({ nameSearch, onNameSearchChange }) => {
  return (
    <>
      <Form.Group className='mb-3' controlId='nameSearch'>
        <Form.Label>Enter part of a name</Form.Label>
        <Form.Control
          type='text'
          placeholder='Enter at least three letters to search'
          value={nameSearch}
          onChange={e => onNameSearchChange(e.target.value)}
        />
      </Form.Group>
    </>
  )
}

export default IndexView
